import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MemberCtx = createContext(null);

export function MemberProvider({ children }) {
  const { user } = useAuth();
  const [members, setMembers] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("hv_active_member") || null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const r = await api.get("/members");
      setMembers(r.data);
      if (!activeId || !r.data.some(m => m.id === activeId)) {
        const self = r.data.find(m => m.is_self) || r.data[0];
        if (self) {
          setActiveId(self.id);
          localStorage.setItem("hv_active_member", self.id);
        }
      }
    } finally { setLoading(false); }
  }, [user, activeId]);

  useEffect(() => { if (user) refresh(); }, [user, refresh]);

  const setActive = useCallback((id) => {
    setActiveId(id);
    localStorage.setItem("hv_active_member", id);
  }, []);

  const active = useMemo(() => members.find(m => m.id === activeId) || null, [members, activeId]);

  const value = useMemo(
    () => ({ members, active, activeId, setActive, refresh, loading }),
    [members, active, activeId, setActive, refresh, loading],
  );

  return <MemberCtx.Provider value={value}>{children}</MemberCtx.Provider>;
}

export const useMembers = () => useContext(MemberCtx);
